/**
 * Utility functions for role-based access control
 */

// Check if user can access user management
export const canAccessUserManagement = (user) => {
  return user?.role === 'superadmin' || (!user?.role && user?.is_admin);
};

// Check if user can access couriers
export const canAccessCouriers = (user) => {
  return user?.role === 'superadmin' || (!user?.role && user?.is_admin);
};

// Check if user can view KPI dashboard
export const canAccessKPI = (user) => {
  return ['superadmin', 'admin'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can view the product list (read-only for sales_executive)
export const canViewProducts = (user) => {
  return ['superadmin', 'admin', 'executive', 'sales_executive', 'packing_manager'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can manage products (create/edit/delete)
export const canManageProducts = (user) => {
  return ['superadmin', 'admin', 'executive'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can manage orders (includes processing orders)
export const canManageOrders = (user) => {
  return ['superadmin', 'admin', 'sales_executive', 'packing_manager'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can view the Requested Orders page (website orders awaiting processing)
export const canViewRequestedOrders = (user) => {
  return ['superadmin', 'admin', 'packing_manager'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can manage customers
export const canManageCustomers = (user) => {
  return ['superadmin', 'admin', 'sales_executive', 'packing_manager'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can dispatch orders via Pathao or Steadfast
export const canDispatchOrders = (user) => {
  return ['superadmin', 'packing_manager'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can manage suppliers and categories
export const canManageSuppliersCategories = (user) => {
  return ['superadmin', 'admin', 'executive'].includes(user?.role) ||
         (!user?.role && user?.is_admin);
};

// Check if user can view sensitive product data (purchase price, stock entered, etc.)
export const canViewSensitiveProductData = (user) => {
  return user?.role === 'superadmin' || user?.role === 'admin' || (!user?.role && user?.is_admin);
};

// Check if user can view profit/cost data on orders
export const canViewProfitData = (user) => {
  return ['superadmin', 'admin'].includes(user?.role) || (!user?.role && user?.is_admin);
};

// Check if user can manage the marketing page (homepage banners)
export const canManageMarketing = (user) => {
  return ['superadmin', 'admin'].includes(user?.role) || (!user?.role && user?.is_admin);
};
export const getDefaultPath = (user) => {
  if (!user) return '/admin/login';
  
  // If no role field (before migration), treat as superadmin
  const role = user.role || 'superadmin';
  
  switch (role) {
    case 'executive':
    case 'sales_executive':
    case 'packing_manager':
    case 'admin':
    case 'superadmin':
    default:
      return '/admin';
  }
};
